import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import TextField from '@material-ui/core/TextField';

const WebsitesFormSection = ({
  value,
  errors,
  handleOnChange,
}) => (
  <div data-test-id="websites">
    <TextField
      label={t('Websites')}
      value={value || ''}
      onChange={event => handleOnChange(event.target.value)}
      error={!!errors}
      helperText={errors}
      inputProps={{
        'data-test-id': 'websites',
      }}
      fullWidth
    />
  </div>
);

WebsitesFormSection.propTypes = {
  value: PropTypes.string,
  errors: PropTypes.string,
  handleOnChange: PropTypes.func.isRequired,
};

export default WebsitesFormSection;
